export default "__VITE_PUBLIC_ASSET__4b75c71b__"